<div class="configuration-list-container">
  <section class="feature-page">
    <app-page-header
      title="Encargos Ministeriales"
      subtitle="Gestiona los encargos disponibles en el sistema"
      icon="volunteer_activism">
    </app-page-header>

    <div class="feature-page__content">
      <mat-card class="table-surface-card">
        <mat-card-content>
          <app-table-surface
              [columns]="columns"
              [data]="tableData"
              [isLoading]="isLoading"
              [enableDragDrop]="enableDragDrop"
              [cellTemplate]="cellTemplate"
              [savingCell]="savingCell"
              [activeFilters]="activeFilterChips"
              tableId="ministry-appointment-list"
              [enableSearch]="true"
              searchPlaceholder="Buscar encargo..."
              [enableFilter]="true"
              [enableColumnVisibility]="true"
              [enableDensity]="true"
              primaryActionLabel="Nuevo"
              (searchChange)="onToolbarSearch($event)"
              (filterRemove)="onFilterRemove($event)"
              (rowReorder)="onAppointmentReorder($event)"
              (cellEditSave)="onCellEditSave($event)"
              (primaryActionClick)="createNew()">
              <div filterPanel class="appointment-filter-panel" [formGroup]="filterForm">
                <app-data-table-multi-select-filter formControlName="status" label="Estado" [options]="statusFilterOptions"></app-data-table-multi-select-filter>

              </div>
            </app-table-surface>

          <ng-template #cellTemplate let-column="column" let-row="row">
            <span *ngIf="column === 'name'">{{ row.name }}</span>
            <mat-slide-toggle
              *ngIf="column === 'isActive'"
              class="status-toggle"
              [checked]="row.isActive"
              (click)="$event.stopPropagation()"
              (change)="onStatusChange(row, $event.checked)"
              aria-label="Cambiar estado">
            </mat-slide-toggle>
            <div *ngIf="column === 'actions'" class="actions-cell">
              <button mat-icon-button matTooltip="Editar" (click)="$event.stopPropagation(); editAppointment(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Eliminar" (click)="$event.stopPropagation(); deleteAppointment(row)">
                <mat-icon color="warn">delete</mat-icon>
              </button>
            </div>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
  </section>
</div>
